import { produce } from "immer";
export function popUpMessage_show(state, message) {
    return produce(state, draftState => {
        draftState.machineState.popUpMessage.message = message;
        draftState.machineState.popUpMessage.isVisible = true;
    });
}
export function popUpMessage_hide(state) {
    return produce(state, draftState => {
        draftState.machineState.popUpMessage.isVisible = false;
    });
}
export function machineState_popUpMessage_hide(machineState) {
    return produce(machineState, draftMachineState => {
        draftMachineState.popUpMessage.isVisible = false;
    });
}
